import React from "react";
// @ts-ignore
import {animateScroll as scroll} from "react-scroll";
import {RowDiv} from "../styledComponents/CustomStyledComponents";
import Colors from "../../assets/colors/Colors";
import expand from "../../assets/images/ic_expand.png";
import styled from "styled-components";
import Images from "../../assets/images/Images";

const EndAlignedTextDiv = styled.div`
    color: white;
    display: flex;
    justify-content: flex-end;
`;
const StartAlignedTextDiv = styled.div`
    text-align: start;
    color: white;
`;

const RoundDiv = styled.div`
    background-color: white;
    border-radius: 40px;
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 3px 6px #00000029;
    cursor: pointer;
`;

const FooterBannerComponent: React.FC = () =>{
    return (
        <RowDiv style={{justifyContent: 'center', backgroundColor: Colors.footerRed, height: 200, zIndex: 99}}>
            <div style={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                <EndAlignedTextDiv >
                  <img src={Images.logoMapfreBrandWhite} style={{ height: 30 }} />
                </EndAlignedTextDiv>
            </div>
            <div style={{flex: 2, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <RoundDiv onClick={() => scroll.scrollToTop()} >
                    <img src={expand} alt="Logo2" style={{height: 10, width: 10, transform: `rotate(180deg)`, cursor: 'pointer'}}/>
                </RoundDiv>
            </div>
            <div style={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
            </div>
        </RowDiv>
    )
};

export default FooterBannerComponent;
